import {
    BillingResponse,
    ClaimTrialCreditResponse,
    CreditSummaryResponse,
    HistoryBillResponse,
    TrialCreditStatusResponse,
    UnsetResponse,
    UpdateBillingRequest,
    UpdateBillingResponse,
} from '@xver/@types/bill';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    CHECK_UNSET: '/v1/billing/check-unset-billing',
    HISTORY: '/v1/billing/history',
    UPDATE: '/v1/billing/update-billing',
    GET: '/v1/billing/billing',
    COUPON_REDEEM: '/v1/billing/coupon-redeem',
    CREDIT_SUMMARY: '/v1/billing/credit-summary',
    TRIAL_CREDIT: '/v1/billing/trial-credit',
    TRIAL_CREDIT_CLAIM: '/v1/billing/trial-credit/claim',
};

export function checkUnsetBilling(): Promise<UnsetResponse> {
    return httpClient.get(ENDPOINTS.CHECK_UNSET);
}

export function getHistoryBill(page?: number, pageSize?: number): Promise<HistoryBillResponse> {
    return httpClient.get(ENDPOINTS.HISTORY, {
        params: { page, page_size: pageSize },
    });
}

export function updateBilling(billingData: UpdateBillingRequest): Promise<UpdateBillingResponse> {
    return httpClient.post(ENDPOINTS.UPDATE, billingData);
}

export function getBilling(): Promise<BillingResponse> {
    return httpClient.get(ENDPOINTS.GET);
}

export function redeemCoupon(coupon: string): Promise<{ message: string }> {
    return httpClient.post(ENDPOINTS.COUPON_REDEEM, { coupon });
}

export function getCreditSummary(): Promise<CreditSummaryResponse> {
    return httpClient.get(ENDPOINTS.CREDIT_SUMMARY);
}

export function getTrialCreditStatus(): Promise<TrialCreditStatusResponse> {
    return httpClient.get(ENDPOINTS.TRIAL_CREDIT);
}

export function claimTrialCredit(): Promise<ClaimTrialCreditResponse> {
    return httpClient.post(ENDPOINTS.TRIAL_CREDIT_CLAIM);
}
